/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 53,
  image: "default-changelog-v2.png",
  title: "Upgraded Compute Shell, Redesigned Color System, Email Settings, Bracket Enhancements & Platform Updates",
  shortDescription: "Optimize user interaction and resource allocation within your platform with these updates: Enhanced compute shell, revamped color system, customizable email preferences, and an innovative bracket system. Elevate your experience today!",
  description: "Optimize user interaction and resource allocation within your platform with these updates: Enhanced compute shell, revamped color system, customizable email preferences, and an innovative bracket system. Elevate your experience today!",
  date: "Jan 10th, 2024",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Spheron", "Shell", "Enhancement", "Compute", "Design system", "fixes", "email", "billing", "gpu"]
};
export const content = `
Compute Shell Enhancement
-------------------------

In an earlier release, we introduced basic shell access, allowing users to interact with their compute instances via text field for running their commands on their instances. Now, with this latest update, we've amplified the shell access experience, empowering users with a robust set of features and capabilities:

- **Improved User Interface:** We've refined the terminal-like UI for better usability, ensuring an intuitive and efficient workflow while working within the instance's shell environment.
- **Extended Command Support:** Enjoy a wider range of commands and functionalities within the instance shell, allowing for more comprehensive instance management and administration.
- **Real-time Interactivity:** Experience enhanced responsiveness and seamless interaction with the instance shell, enabling quicker execution of commands and immediate feedback.

## Improved Color System

We have focused on enhancing the visual experience through an improved Color System. In this release, we have made significant changes to the way colors are utilized across the platform, aligning with our newly constructed design system for enhanced consistency and a unified user interface.

**Key Changes:**

- Complete overhaul of the existing color system to ensure consistency across the platform
- Integration of a new set of colors designed specifically for both the light and dark versions of our UI
- Emphasis on maintaining design standards and coherence throughout the platform

**Benefits of the Update:**

- Enhanced visual appeal with a more cohesive color palette
- Improved consistency in design elements across different sections of the platform
- Better alignment with the overall user experience, providing a more polished look and feel

## Email Preferences

We have added the provision in our platform to manage your email notification preferences right from your organization settings page. Tailor your email preferences by category, allowing you to enable or disable notifications for specific types of emails making it easy to adjust and fine-tune your email notifications based on your preferences and workflow.

## Introducing Bracket System

We have introduced an innovative system that dynamically adjusts compute resource allocation based on the remaining balance in your wallet. This feature offers users the flexibility to deploy compute resources aligned with your available funds, optimizing resource utilization within Spheron compute.

**How the Bracket System Works:**

- **Balance-Driven Compute Allocation:** The platform now operates on a bracket system where the amount available in your wallet determines the level of compute resources you can use.
- **Tailored Compute Options:** Depending on your wallet balance, the available compute resources have been categorized into brackets. Following are the details:

| Price Range | CPU | RAM(in GB) | Storage(in GB) |
| ----------- | --- | ---------- | -------------- |
| $15         | 8   | 32         | 512            |
| $15 - $45   | 24  | 96         | 1536           |
| $45 - $100  | 56  | 224        | 3584           |
| $100 - $500 | 128 | 512        | 5760           |

**For example:** if you have $30 in your compute balance then as per the above bracket, you can deploy compute instances with specifications as 24 CPUs, 96 GB RAM & 1536 GB storage.

## Platform Improvements & Fixes

- **Capacity Availability:** We are showing users whether the capacity of instance is available or not. And added a provision to contact our team if the requested resources are out of stock.
- **GPU Instance Plans:** We have filtered some AI templates where GPU plans were shown even when user has selected CPU powered compute type.
- **Community Public Organisation URL:** We have added a provision to copy the organisation URL after user makes the organisation public.
- **Compute Usage:** We have fixed the inconsistencies in total compute usage data shown on compute usage page.
- **Compute Instance Billing:** We have fixed the calculation logic for amount to be billed when compute instance is deleted.
- **Top-up minimum amount:** We have introduced a restriction for users to add minimum of $15 to be deposited in their compute balance. Same restriction is added on auto-topup amount as well.
- We have fixed the issue when instance details page was breaking after refreshing in some specific cases.
- We have disabled spot instance deployments for CPU based instances.
- We have fixed the issue where incorrect tooltip is showing on storage billing page.
  `;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
